import moment from 'moment';
import { timezoneList } from 'ui_system/select/timezone_select/timezoneList';

export { timezoneList };

// LocalStorage reader/setter
const localStorageKey = 'currentTimezone';
export const setSavedTimezone = (tz) => {
  try {
    localStorage.setItem(localStorageKey, tz);
  } catch (e) {}
};
export const getSavedTimezone = () => {
  let savedTimezone;
  try {
    savedTimezone = localStorage.getItem(localStorageKey);
  } catch (e) {}

  if (savedTimezone && savedTimezone.length > 0) return savedTimezone;

  const momentTimezone = moment.tz.guess();
  const matchingTimezone = timezoneList[momentTimezone];

  if (matchingTimezone) return matchingTimezone.value;
  return null;
};

// Convert a date+time from originalTimezone to timezone
export const convertDateTimezone = ({
  originalTimezone,
  timezone,
  date,
  dateFormat = 'YYYY-MM-DD',
  time,
  timeFormat = 'h:mma',
}) => {
  return moment
    .tz(date + time.trim(), `${dateFormat}${timeFormat}`, originalTimezone)
    .tz(timezone);
};

// Get the abbreviation "code" of the timezone
export const timezoneCode = (timezone) => {
  const { code } = timezoneList[timezone];
  return code || moment.tz.zone(timezone).abbr(moment());
};

/**
 * Returns correct input mask for the given date format
 * @param {String} dateFormat
 * @return {String}
 */
export const getDateMask = (dateFormat) => {
  if (dateFormat && typeof dateFormat === 'string') {
    if (dateFormat === 'YYYY/MM/DD') {
      return '1111/11/11';
    }
    return '11/11/1111';
  }
  return '';
};

/**
 * Gets translatable value from date format string
 * @param {String} dateFormat
 * @return {String}
 */
export const getDatePlaceholder = (dateFormat) => {
  if (dateFormat && typeof dateFormat === 'string') {
    const placeholders = {
      'MM/DD/YYYY': 'MM_DD_YYYY',
      'DD/MM/YYYY': 'DD_MM_YYYY',
      'YYYY/MM/DD': 'YYYY_MM_DD',
    };
    return placeholders[dateFormat];
  }
  return '';
};

/**
 * Check if answer is a valid date in the provided date format
 * @param {String} answer
 * @param {String} dateFormat
 * @return {Boolean}
 */
export const isValidDate = (answer, dateFormat) => {
  if (answer && dateFormat) {
    return moment(answer, dateFormat, true).isValid();
  }
  return false;
};
